// @flow

import React, { useState, useCallback, useEffect } from 'react'
import styled, { css } from 'styled-components'
import handleViewport from 'react-in-viewport'
import { DESKTOP } from '@streamr/streamr-layout/styled'

type ViewportProps = {
    innerRef: any,
    inViewport?: boolean,
}

type Props = ViewportProps & {
    current: number,
    total: number,
    className?: string,
    active?: boolean,
}

const Root = styled.div`
    opacity: 0;
    transition-delay: 0s, 0.2s;
    transition-property: opacity, visibility;
    transition: 0.3s ease-in-out;
    visibility: hidden;

    ${({ active }) => !!active && css`
        opacity: 1;
        transition-delay: 0.3s, 0s;
        visibility: visible;
    `}
`

const UnstyledIndexLabel = ({
    inViewport,
    active: activeProp,
    current,
    total,
    className,
    innerRef,
}: Props) => {
    const finalActive = !!activeProp && !!inViewport

    const [active, setActive] = useState(finalActive)

    const hide = useCallback(() => {
        setActive(false)
    }, [])

    useEffect(() => {
        hide()
    }, [hide])

    useEffect(() => {
        if (active !== finalActive) {
            setActive(finalActive)
        }
    }, [active, finalActive])

    return (
        <Root className={className} active={active}>
            <span ref={innerRef}>
                {`${current} of ${total}`}
            </span>
        </Root>
    )
}

const IndexLabel = styled(handleViewport(UnstyledIndexLabel))`
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 1em;
    color: white;
    font-size: 10px;
    line-height: 2em;
    padding: 0 1em;

    @media (min-width: ${DESKTOP}px) {
        font-size: 12px;
    }
`

export default IndexLabel
